<script setup lang="ts">
// This starter template is using Vue 3 <script setup> SFCs
// Check out https://vuejs.org/api/sfc-script-setup.html#script-setup
import { UIContentWrap } from "@gohighlevel/ghl-ui";
import Postmate from "postmate";
import { onMounted } from "vue";
import { useAppStore } from "./store/app";
import { setupPendo } from "./util/pendoConfig";
import * as Sentry from "@sentry/vue";
import { setSentryMeta } from "common/util/setupSentry";
import { updateI18nLocale } from "./plugin/vue-i18n";

onMounted(() => {
  const appStore = useAppStore();

  if (process.env.NODE_ENV === "development") {
    Postmate.debug = true;
  }

  const handshake = new Postmate.Model({
    "refresh-token": (token: string) => appStore.refreshToken(token),
    "abort-deletion": (data: object) => appStore.abortDeletion(data),
  });

  handshake.then(({ model }: any) => {
    appStore.initialize(model);
    appStore.setAppHandshake(handshake);
    setupPendo(model);

    // Update i18n locale from model
    const locale = model.locale || model.localeLanguage || "en";
    updateI18nLocale(locale);

    setSentryMeta(Sentry, {
      userId: model.userId,
      companyId: model.companyId,
      locationId: model.locationId,
      email: model.userEmail,
      locale: locale,
    });
  });
});
</script>

<template>
  <UIContentWrap class="bg-white">
    <router-view></router-view>
  </UIContentWrap>
</template>

<style scoped></style>
